module.exports = __webpack_public_path__ + "static/item-section-10-15c9b5f707f1f1721c432d6310081354.png";